import { MultiCombobox } from "../../MultiCombobox.js";
import { FieldItem, useFieldContext } from "../../../../FieldItem-DW8E0eBd.js";
import { jsx } from "react/jsx-runtime";
// src/blocks/Form/connectors/MultiComboboxField.tsx
/**
* Multi-selection field. State is `string[]`.
*
* - ⚠️ Imported by name, not `field.*`: `fieldComponents` doesn't shake per key, and registering it
*   cost every `useAppForm` consumer +45 kB brotli.
* - Reads the field from context; render it inside `form.AppField`.
* - `string` items only — objects would put presentation into the payload; use `itemToLabel`.
*/
const MultiComboboxField = ({ label, action, required, requiredMark, help, tooltip, className, "aria-describedby": ariaDescribedBy, inputClassName, ...comboboxProps }) => {
	const field = useFieldContext();
	return /* @__PURE__ */ jsx(FieldItem, {
		label,
		action,
		required,
		requiredMark,
		help,
		tooltip,
		className,
		"aria-describedby": ariaDescribedBy,
		children: ({ "aria-invalid": isInvalid, ...control }) => /* @__PURE__ */ jsx(MultiCombobox, {
			...comboboxProps,
			...control,
			"aria-invalid": isInvalid,
			state: isInvalid === true ? "error" : void 0,
			className: inputClassName,
			value: field.state.value ?? [],
			onValueChange: (next) => field.handleChange(next),
			onBlur: field.handleBlur
		})
	});
};
export { MultiComboboxField };

//# sourceMappingURL=MultiComboboxField.js.map